

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class Format_ManagedObject

class Format_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: consumptionMeasureType
    set consumptionMeasureType(value:number) {
        this.setValueForKey(value, 'consumptionMeasureType');
    }
    get consumptionMeasureType():number {
        return this.valueForKey('consumptionMeasureType');
    }
    set consumptionMeasureTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'consumptionMeasureType');
    }
    get consumptionMeasureTypePrimitiveValue():number {
        return this.primitiveValueForKey('consumptionMeasureType');
    }

    // Property: consumptionQuantity
    set consumptionQuantity(value:number) {
        this.setValueForKey(value, 'consumptionQuantity');
    }
    get consumptionQuantity():number {
        return this.valueForKey('consumptionQuantity');
    }
    set consumptionQuantityPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'consumptionQuantity');
    }
    get consumptionQuantityPrimitiveValue():number {
        return this.primitiveValueForKey('consumptionQuantity');
    }

    // Property: invitationValue
    set invitationValue(value:number) {
        this.setValueForKey(value, 'invitationValue');
    }
    get invitationValue():number {
        return this.valueForKey('invitationValue');
    }
    set invitationValuePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'invitationValue');
    }
    get invitationValuePrimitiveValue():number {
        return this.primitiveValueForKey('invitationValue');
    }

    // Property: lossMeasureType
    set lossMeasureType(value:number) {
        this.setValueForKey(value, 'lossMeasureType');
    }
    get lossMeasureType():number {
        return this.valueForKey('lossMeasureType');
    }
    set lossMeasureTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'lossMeasureType');
    }
    get lossMeasureTypePrimitiveValue():number {
        return this.primitiveValueForKey('lossMeasureType');
    }

    // Property: lossQuantity
    set lossQuantity(value:number) {
        this.setValueForKey(value, 'lossQuantity');
    }
    get lossQuantity():number {
        return this.valueForKey('lossQuantity');
    }
    set lossQuantityPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'lossQuantity');
    }
    get lossQuantityPrimitiveValue():number {
        return this.primitiveValueForKey('lossQuantity');
    }

    // Property: modifiersRequired
    set modifiersRequired(value:boolean) {
        this.setValueForKey(value, 'modifiersRequired');
    }
    get modifiersRequired():boolean {
        return this.valueForKey('modifiersRequired');
    }
    set modifiersRequiredPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'modifiersRequired');
    }
    get modifiersRequiredPrimitiveValue():boolean {
        return this.primitiveValueForKey('modifiersRequired');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: totalConsumptionMeasureType
    set totalConsumptionMeasureType(value:number) {
        this.setValueForKey(value, 'totalConsumptionMeasureType');
    }
    get totalConsumptionMeasureType():number {
        return this.valueForKey('totalConsumptionMeasureType');
    }
    set totalConsumptionMeasureTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'totalConsumptionMeasureType');
    }
    get totalConsumptionMeasureTypePrimitiveValue():number {
        return this.primitiveValueForKey('totalConsumptionMeasureType');
    }

    // Property: totalConsumptionQuantity
    set totalConsumptionQuantity(value:number) {
        this.setValueForKey(value, 'totalConsumptionQuantity');
    }
    get totalConsumptionQuantity():number {
        return this.valueForKey('totalConsumptionQuantity');
    }
    set totalConsumptionQuantityPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'totalConsumptionQuantity');
    }
    get totalConsumptionQuantityPrimitiveValue():number {
        return this.primitiveValueForKey('totalConsumptionQuantity');
    }

    // Property: waReference
    set waReference(value:string) {
        this.setValueForKey(value, 'waReference');
    }
    get waReference():string {
        return this.valueForKey('waReference');
    }
    set waReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'waReference');
    }
    get waReferencePrimitiveValue():string {
        return this.primitiveValueForKey('waReference');
    }

    // Relationship: productFormats
    protected _productFormats:MIOManagedObjectSet = null;
    get productFormats():MIOManagedObjectSet {
        return this.valueForKey('productFormats');
    }
    addProductFormatsObject(value:ProductFormat) {
        this._addObjectForKey(value, 'productFormats');
    }
    removeProductFormatsObject(value:ProductFormat) {
        this._removeObjectForKey(value, 'productFormats');
    }
}
